<template>

  <div v-if="cerfa">
    <div v-if="readOnly" class="form-group text-center">
      <div @click="downloadForm()" class="btn btn-primary">
        Télécharger le formulaire
      </div>
    </div>
    <div
      class="form-group"
      :style="!readOnly ? 'border-top: 1px dashed #e5e5e5;' : ''"
    >
      <b-row v-if="!readOnly">
        <b-col xl="3" lg="4" md="5" sm="12" cols="12" class="no-padding">
          <label class="control-label">Ajouter un contact ?</label>
        </b-col>
        <b-col xl="9" lg="8" md="7" sm="12" cols="12" class="form-with-label">
          <b-form-checkbox
            v-model="isContact"
            :value="true"
            :unchecked-value="false"
          >
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="!readOnly && cerfa.natureWorkOther != 'Travaux de câblage'">
        <b-col xl="3" lg="4" md="5" sm="12" cols="12" class="no-padding">
          <label class="control-label"
            >Ajouter une description détaillée ?</label
          >
        </b-col>
        <b-col xl="9" lg="8" md="7" sm="12" cols="12" class="form-with-label">
          <b-form-checkbox
            v-model="isDescription"
            :value="true"
            :unchecked-value="false"
          >
          </b-form-checkbox>
        </b-col>
      </b-row>
    </div>
    <div
      v-if="isContact == true || readOnly"
      :class="!readOnly ? '' : 'block-flat outlined'"
    >
      <div :class="!readOnly ? 'header' : 'header readonly mb-3 no-padding'">
        <h3>Contact</h3>
      </div>
      <div class="form-group">
        <b-row>
          <b-col lg="3" md="3" sm="12" cols="12">
            <label class="control-label">Nom : </label>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <b-form-input v-if="!readOnly" v-model="cerfa.contactLastName" />
            <div class="info-value" v-else>{{ cerfa.contactLastName }}</div>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <label class="control-label">Prénom : </label>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <b-form-input v-if="!readOnly" v-model="cerfa.contactFirstName" />
            <div class="info-value" v-else>{{ cerfa.contactFirstName }}</div>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <label class="control-label">Téléphone : </label>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <b-form-input v-if="!readOnly" v-model="cerfa.contactPhone" />
            <div class="info-value" v-else>{{ cerfa.contactPhone }}</div>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <label class="control-label">Télécopie : </label>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <b-form-input v-if="!readOnly" v-model="cerfa.contactFax" />
            <div class="info-value" v-else>{{ cerfa.contactFax }}</div>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <label class="control-label">Numéro de dossier : </label>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <b-form-input v-if="!readOnly" v-model="cerfa.contactNumFolder" />
            <div class="info-value" v-else>{{ cerfa.contactNumFolder }}</div>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <label class="control-label">Email : </label>
          </b-col>
          <b-col lg="3" md="3" sm="12" cols="12">
            <b-form-input v-if="!readOnly" v-model="cerfa.contactEmail" />
            <div class="info-value" v-else>{{ cerfa.contactEmail }}</div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div
      v-if="isDescription == true || readOnly"
      :class="!readOnly ? '' : 'block-flat outlined'"
    >
      <div :class="!readOnly ? 'header' : 'header readonly mb-3 no-padding'">
        <h3>Description des travaux</h3>
      </div>
      <div class="form-group">
        <b-row>
          <b-col xl="6" lg="7" md="6" sm="12" cols="12" class="no-padding">
            <label class="control-label"
              >Numéro de consultation du téléservice (tracabilite) :
            </label>
          </b-col>
          <b-col xl="6" lg="5" md="6" sm="12" cols="12">
            <b-form-input v-if="!readOnly" v-model="cerfa.teleServiceNumber" />
            <div class="info-value" v-else>{{ cerfa.teleServiceNumber }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="2" md="2" sm="12" cols="12">
            <label class="control-label">Déclaration L. 49 du CPCE : </label>
          </b-col>
          <b-col lg="10" md="10" sm="12" cols="12">
            <ValidationProvider
              mode="lazy"
              v-if="!readOnly"
              v-slot="{ errors }"
              rules="required"
              name="Déclaration L. 49 du CPCE"
            >
              <b-form-radio-group
                :state="errors[0] ? false : null"
                v-model="cerfa.isCpce"
                :options="options"
              ></b-form-radio-group>
            </ValidationProvider>
            <div class="info-value" v-else>
              {{ cerfa.isCpce == true ? "Oui" : "Non" }}
            </div>
          </b-col>
        </b-row>
        <b-row v-if="cerfa.isCpce == true">
          <b-col cols="12" class="text-center no-padding">
            <a href="http://avenir.crige-paca.org/" target="_blank"
              >Guichet des déclarations de travaux | AVENIR</a
            >
          </b-col>
          <b-col lg="2" md="2" sm="12" cols="12">
            <label class="control-label">Date déclaration : </label>
          </b-col>
          <b-col lg="4" md="4" sm="12" cols="12">
            <b-form-datepicker
              hide-header
              v-if="!readOnly"
              placeholder="Date"
              today-button
              :start-weekday="1"
              today-button-variant="primary"
              label-help=""
              label-today-button="Aujourd'hui"
              v-model="cerfa.dateCpce"
            ></b-form-datepicker>
            <div class="info-value" v-else>{{ cerfa.dateCpce }}</div>
          </b-col>
          <b-col lg="2" md="2" sm="12" cols="12">
            <label class="control-label">Numéro déclaration : </label>
          </b-col>
          <b-col lg="4" md="4" sm="12" cols="12">
            <b-form-input
              v-if="!readOnly"
              v-model="cerfa.numberCpce"
              type="text"
            />
            <div class="info-value" v-else>{{ cerfa.numberCpce }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="2" md="2" sm="12" cols="12">
            <label class="control-label">Visite préalable : </label>
          </b-col>
          <b-col lg="10" md="10" sm="12" cols="12">
            <ValidationProvider
              mode="lazy"
              v-if="!readOnly"
              v-slot="{ errors }"
              rules="required"
              name="Visite préalable"
            >
              <b-form-radio-group
                :state="errors[0] ? false : null"
                v-model="cerfa.isPreliminaryVisit"
                :options="options"
              ></b-form-radio-group>
            </ValidationProvider>
            <div class="info-value" v-else>
              {{ cerfa.isPreliminaryVisit == true ? "Oui" : "Non" }}
            </div>
          </b-col>
        </b-row>
        <b-row v-if="cerfa.isPreliminaryVisit == true">
          <b-col lg="2" md="2" sm="12" cols="12">
            <label class="control-label">Visite préalable : </label>
          </b-col>
          <b-col lg="10" md="10" sm="12" cols="12">
            <b-form-datepicker
              hide-header
              v-if="!readOnly"
              placeholder="Date"
              today-button
              :start-weekday="1"
              today-button-variant="primary"
              label-help=""
              label-today-button="Aujourd'hui"
              v-model="cerfa.datePreliminaryVisit"
            ></b-form-datepicker>

            <div v-else class="info-value">
              {{ cerfa.datePreliminaryVisit }}
            </div>
          </b-col>
        </b-row>
        <!-- <b-row>
					<b-col lg="2" md="2" sm="12" cols="12" class="no-padding">
						<label class="control-label">Déclaration d'amenagement numérique</label>
					</b-col>
					<b-col lg="10" md="10" sm="12" cols="12" class="no-padding">
						<b-form-input
						:disabled="readOnly"
							v-model="cerfa.digitalPlanningDeclaration"
							class="form-control send-api"
						/>
					</b-col>
				</b-row> -->
        <b-row>
          <b-col xl="4" lg="4" md="4" sm="12" cols="12" class="no-padding">
            <label class="control-label">Support : </label>
          </b-col>
          <b-col xl="8" lg="8" md="8" sm="12" cols="12" class="form-with-label">
            <b-form-radio-group
              v-if="!readOnly"
              v-model="cerfa.ftth"
              :options="ftthOptions"
            ></b-form-radio-group>
            <div v-else>{{ cerfa.ftth }}</div>
          </b-col>
          <!-- <b-col xl="4" lg="7" md="6" sm="12" cols="12" class="no-padding">
            <label class="control-label"
              >Déclaration du projet de travaux DT :</label
            >
          </b-col>
          <b-col xl="3" lg="5" md="6" sm="12" cols="12" class="form-with-label">
            <b-form-radio-group
              v-if="!readOnly"
              v-model="cerfa.workProjectDeclaration"
              :options="options"
            ></b-form-radio-group>
            <div v-else>
              {{ cerfa.workProjectDeclaration === true ? "Oui" : "Non" }}
            </div>
          </b-col> -->
        </b-row>

        <b-row>
          <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
            <table class="table-front custome">
              <tr>
                <td width="20%" rowspan="2" class="text-center">
                  Type de travaux
                </td>
                <td width="40%" colspan="3" class="text-center">
                  Longueur et nombre
                </td>
                <td width="40%" colspan="3" class="text-center">
                  Évaluation du patrimoine
                </td>
              </tr>
              <tr>
                <td width="10%">Unité</td>
                <td width="15%">Dépose</td>
                <td width="15%">Pose</td>
                <td width="10%">Unité</td>
                <td width="15%">Dépose</td>
                <td width="15%">Pose</td>
              </tr>
              <tr>
                <td rowspan="2">Canalisation / fourreau</td>
                <td>Longueur (m)</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pipelineDepositLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pipelineDepositLength }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pipelinePoseLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pipelinePoseLength }}</div>
                </td>
                <td rowspan="2">Longueur totale (m)</td>
                <td rowspan="2">
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pipelineDepositTotalLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pipelineDepositTotalLength }}</div>
                </td>
                <td rowspan="2">
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pipelinePoseTotalLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pipelinePoseTotalLength }}</div>
                </td>
              </tr>
              <tr>
                <td>Nombre</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pipelineDepositNumber"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pipelineDepositNumber }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pipelinePoseNumber"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pipelinePoseNumber }}</div>
                </td>
              </tr>
              <tr>
                <td rowspan="2">Câble Enterré</td>
                <td>Longueur (m)</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.buriedCableDepositLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.buriedCableDepositLength }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.buriedCablePoseLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.buriedCablePoseLength }}</div>
                </td>
                <td rowspan="2">Longueur totale (m)</td>
                <td rowspan="2">
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.buriedCableDepositTotalLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.buriedCableDepositTotalLength }}</div>
                </td>
                <td rowspan="2">
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.buriedCablePoseTotalLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.buriedCablePoseTotalLength }}</div>
                </td>
              </tr>
              <tr>
                <td>Nombre</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.buriedCableDepositNumber"
                    type="number"
                  />
                  <div v-else>{{ cerfa.buriedCableDepositNumber }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.buriedCablePoseNumber"
                    type="number"
                  />
                  <div v-else>{{ cerfa.buriedCablePoseNumber }}</div>
                </td>
              </tr>
              <tr>
                <td>Artère aérienne</td>
                <td>Longueur (m)</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.airArteryDepositLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.airArteryDepositLength }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.airArteryPoseLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.airArteryPoseLength }}</div>
                </td>
                <td>Longueur total (m)</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.airArteryDepositTotalLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.airArteryDepositTotalLength }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.airArteryPoseTotalLength"
                    type="number"
                  />
                  <div v-else>{{ cerfa.airArteryPoseTotalLength }}</div>
                </td>
              </tr>
              <tr>
                <td>Armoire de S.R / Shelter</td>
                <td>Nombre</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.cupboardsNumberDeposit"
                    type="number"
                  />
                  <div v-else>{{ cerfa.cupboardsNumberDeposit }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.cupboardsNumberPose"
                    type="number"
                  />
                  <div v-else>{{ cerfa.cupboardsNumberPose }}</div>
                </td>
                <td>m²</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.cupboardsSurfDeposit"
                    type="number"
                  />
                  <div v-else>{{ cerfa.cupboardsSurfDeposit }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.cupboardsSurfPose"
                    type="number"
                  />
                  <div v-else>{{ cerfa.cupboardsSurfPose }}</div>
                </td>
              </tr>
              <tr>
                <td>Borne pavillonnaire</td>
                <td>Nombre</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pavilionBollardNumberDeposit"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pavilionBollardNumberDeposit }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pavilionBollardNumberPose"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pavilionBollardNumberPose }}</div>
                </td>
                <td>m²</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pavilionBollardSurfDeposit"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pavilionBollardSurfDeposit }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.pavilionBollardSurfPose"
                    type="number"
                  />
                  <div v-else>{{ cerfa.pavilionBollardSurfPose }}</div>
                </td>
              </tr>
              <tr>
                <td>Poteau</td>
                <td>Nombre</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.poleNumberDeposit"
                    type="number"
                  />
                  <div v-else>{{ cerfa.poleNumberDeposit }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.poleNumberPose"
                    type="number"
                  />
                  <div v-else>{{ cerfa.poleNumberPose }}</div>
                </td>
                <td colspan="3"></td>
              </tr>
              <tr>
                <td>Chambre</td>
                <td>Nombre</td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.undergroundChamberNumberDeposit"
                    type="number"
                  />
                  <div v-else>{{ cerfa.undergroundChamberNumberDeposit }}</div>
                </td>
                <td>
                  <b-form-input
                    v-if="!readOnly"
                    v-model="cerfa.undergroundChamberNumberPose"
                    type="number"
                  />
                  <div v-else>{{ cerfa.undergroundChamberNumberPose }}</div>
                </td>
                <td colspan="3"></td>
              </tr>
            </table>
          </b-col>
        </b-row>

        <b-row>
          <b-col xl="3" lg="3" md="6" sm="12" cols="12" class="no-padding">
            <label class="control-label">Diamètre du tuyau (mm) :</label>
          </b-col>
          <b-col xl="9" lg="9" md="6" sm="12" cols="12">
            <b-form-input
              v-if="!readOnly"
              v-model="cerfa.customePipeDiameter"
              type="number"
            />
            <div v-else>{{ cerfa.customePipeDiameter }}</div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
export default {
  name: "CustomeFormD14023",
  props: ["value", "readOnly"],
  data() {
    return {
      isContact: false,
      ftthOptions: [
        { text: "support ", value: "FTTH" },
        { text: "Mobile ", value: "Mobile" },
        { text: "Cuivre ", value: "Cuivre" },
        { text: "THD Radio ", value: "THD Radio" },
      ],
      options: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      isDescription: false,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.isContact = true;
      this.isDescription = true;
    }
  },
  methods: {
    downloadForm() {
      let id = this.$route.params.id;
      Vue.axios
        .get(window.urlapi + "request/" + id + "/pdf/var")
        .then((response) => {
          window.open(response.data.message);
        });
    },
    ...Vuex.mapActions("Cerfa", ["setCerfa14023"]),
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14023"]),
    cerfa: {
      get: function () {
        return this.cerfa14023;
      },
      set: function (newValue) {
        this.setCerfa14023(newValue);
      },
    },
  },
};
</script>

<style></style>
